const BackendServerConfig = {
    BackendServer : process.env.REACT_APP_BACKEND_API,
    WebSocketURL: process.env.REACT_APP_WEB_SOCKET_URL
    
}

export default BackendServerConfig;